"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ACCESSIBILITY_CATEGORY_KEY = 'base';
exports.ACCESSIBILITY_COMPONENT_KEY = 'accessibility';